import { Container, Paper } from '@mui/material';

import PendingMailTable from '../components/patients/PendingMailTable';

const PendingMailSummary = ({ role }) => {
  return (
    <Container maxWidth="xl" sx={{ pt: 4, pb: 4 }}>
      <Paper elevation={3} sx={{ padding: 3, pt: 2 }}>
        <PendingMailTable role={role} />
      </Paper>
    </Container>
  );
};

export default PendingMailSummary;

